/** Mapeia o valor `icone` da origem de lead para o componente em LeadSourceIcons.vue */
const LEAD_SOURCE_ICON_MAP = {
  facebook: 'FacebookIcon',
  instagram: 'InstagramIcon',
  whatsapp: 'WhatsAppIcon',
  linkedin: 'LinkedInIcon',
  youtube: 'YouTubeIcon',
  tiktok: 'TikTokIcon',
  twitter: 'TwitterIcon',
  telegram: 'TelegramIcon',
  google: 'GoogleIcon',
  bing: 'BingIcon',
  website: 'WebsiteIcon',
  site: 'WebsiteIcon',
  internet: 'InternetIcon',
  blog: 'BlogIcon',
  'landing-page': 'LandingPageIcon',
  ecommerce: 'EcommerceIcon',
  amazon: 'AmazonIcon',
  mercadolivre: 'MercadoLivreIcon',
  shopee: 'ShopeeIcon',
  email: 'EmailIcon',
  'email-marketing': 'EmailMarketingIcon',
  newsletter: 'NewsletterIcon',
  webinar: 'WebinarIcon',
  'google-ads': 'GoogleAdsIcon',
  'facebook-ads': 'FacebookAdsIcon',
  'instagram-ads': 'InstagramAdsIcon',
  affiliate: 'AffiliateIcon',
  event: 'EventIcon',
  conference: 'ConferenceIcon',
  workshop: 'WorkshopIcon',
  networking: 'NetworkingIcon',
  referral: 'ReferralIcon',
  indicacao: 'ReferralIcon',
  form: 'LandingPageIcon',
  formulário: 'LandingPageIcon',
  formulario: 'LandingPageIcon',
  'word-of-mouth': 'WordOfMouthIcon',
  partner: 'PartnerIcon',
  phone: 'PhoneIcon',
  street: 'StreetIcon',
  'walk-in': 'WalkInIcon',
  'store-visit': 'StoreVisitIcon',
  'office-visit': 'OfficeVisitIcon',
  mail: 'MailIcon',
  radio: 'RadioIcon',
  tv: 'TvIcon',
  newspaper: 'NewspaperIcon',
  magazine: 'MagazineIcon',
  billboard: 'BillboardIcon',
  'app-store': 'AppStoreIcon',
  'play-store': 'PlayStoreIcon',
  'qr-code': 'QrCodeIcon',
  chatbot: 'ChatbotIcon',
  'live-chat': 'LiveChatIcon',
  'real-estate': 'RealEstateIcon',
  automotive: 'AutomotiveIcon',
  healthcare: 'HealthcareIcon',
  education: 'EducationIcon',
  finance: 'FinanceIcon',
  insurance: 'InsuranceIcon',
  legal: 'LegalIcon',
  consulting: 'ConsultingIcon',
  technology: 'TechnologyIcon',
  retail: 'RetailIcon',
  other: 'OtherIcon',
  outros: 'OtherIcon',
  unknown: 'UnknownIcon'
}

export function getLeadSourceIcon(iconValue) {
  if (!iconValue) return 'WebsiteIcon'
  const key = String(iconValue).trim().toLowerCase()
  return LEAD_SOURCE_ICON_MAP[key] || 'WebsiteIcon'
}
